export const serviceCategories = [
  {
    id: 'sc-1',
    name: 'Elétrica',
    slug: 'eletrica',
    description: 'Instalação, manutenção e reparos elétricos residenciais e comerciais',
    icon: '⚡',
    providers_count: 45,
    average_rating: 4.7,
    created_at: new Date().toISOString()
  },
  {
    id: 'sc-2',
    name: 'Encanamento e Hidráulica',
    slug: 'encanamento',
    description: 'Serviços de encanamento, instalação de tubulações e reparos hidráulicos',
    icon: '🚰',
    providers_count: 38,
    average_rating: 4.6,
    created_at: new Date().toISOString()
  },
  {
    id: 'sc-3',
    name: 'Jardinagem e Paisagismo',
    slug: 'jardinagem',
    description: 'Manutenção de jardins, paisagismo e serviços de jardinagem',
    icon: '🌿',
    providers_count: 32,
    average_rating: 4.8,
    created_at: new Date().toISOString()
  },
  {
    id: 'sc-4',
    name: 'Limpeza e Conservação',
    slug: 'limpeza',
    description: 'Serviços de limpeza residencial, comercial e pós-obra',
    icon: '🧹',
    providers_count: 52,
    average_rating: 4.5,
    created_at: new Date().toISOString()
  },
  {
    id: 'sc-5',
    name: 'Pintura',
    slug: 'pintura',
    description: 'Pintura residencial e comercial, textura e acabamentos',
    icon: '🎨',
    providers_count: 28,
    average_rating: 4.6,
    created_at: new Date().toISOString()
  },
  {
    id: 'sc-6',
    name: 'Marcenaria',
    slug: 'marcenaria',
    description: 'Móveis planejados, marcenaria e carpintaria',
    icon: '🪚',
    providers_count: 24,
    average_rating: 4.7,
    created_at: new Date().toISOString()
  }
];
